module.exports = "<router-outlet></router-outlet>\n<ng-http-loader></ng-http-loader>"